import { ArrowRight, Construction } from "lucide-react"
import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"

/**
 * Вкладки Whitelist и Custom lists (AMEND-12 §7).
 *
 * Вёрстка раздела на месте, содержимого нет — и написано прямым текстом,
 * почему: в выгрузке SEON этих списков нет ни строкой. Нарисованная пустая
 * таблица читалась бы как «список есть, он пуст», то есть как утверждение о
 * данных, которого мы сделать не можем. Белый список, придуманный на глаз,
 * вдобавок значил бы, что кого-то пропускают мимо проверок.
 *
 * Хранилище шага 1 при этом на списки уже рассчитано: имя списка — колонка
 * (`list_name`), и та же таблица примет их, когда появится выгрузка.
 */
export function EmptyListTab({ title, kind }: { title: string; kind: string }) {
  return (
    <div className="p-5">
      <div className="mx-auto max-w-lg rounded border border-line bg-surface p-6 shadow-panel">
        <div className="flex items-center gap-2 text-fg-muted">
          <Construction className="h-4 w-4" strokeWidth={1.75} />
          <span className="stencil-label">Not implemented</span>
        </div>
        <p className="mt-3 text-sm leading-relaxed text-fg">
          <span className="font-semibold">{title}</span> is part of the paydetect Lists layout, but this
          build carries no {kind} data.
        </p>
        <p className="mt-2 text-xs leading-relaxed text-fg-muted">
          The SEON export we were given holds blacklist entries only. Nothing is loading here and
          nothing is hidden — the storage behind Lists already keeps the list name per row, so this
          tab fills up the day such an export exists.
        </p>
        <Button asChild variant="primary" className="mt-5">
          <Link to="/lists">
            Open Blacklist
            <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.25} />
          </Link>
        </Button>
      </div>
    </div>
  )
}
